import React,{useState, createContext,useRef} from 'react'
import {Outlet} from 'react-router-dom'
import '../../styles/photos.css'
import '../../styles/common.css'
import ScrollRestoration from '../common/onWindowLoadUp.jsx'

import PhotosHeader from './photosHeader.jsx'
import PhotosFooter from './photosFooter.jsx'
import ScrollUp from '../common/ScrollUp.jsx'
import RouteTracker from '../common/routeTracker.jsx'
import GptAd from '../ads/gptAd.jsx'



 export  const DeviceContext = createContext();       
        

const Photos = ({isMobile}) => {

           const [photosActiveHeaderLink,setPhotosActiveHeaderLink]=useState("Home")
            const [mobile,setMobile] = useState(isMobile)
           const photosMainContainerRef = useRef(null);
          

          return (
                 
               

                       <div className='photos-container' ref={photosMainContainerRef}>
                              <PhotosHeader photosActiveHeaderLink={photosActiveHeaderLink} />
                             
                               <DeviceContext.Provider value={{mobile,setMobile,containerRef:photosMainContainerRef}}>
                              <div className="photos-content">
                            
                                    <Outlet />
              
                              </div>
                                </DeviceContext.Provider>
                              <PhotosFooter />
                              <ScrollUp containerSelector={'.photos-container'} />
                       <ScrollRestoration containerRef={photosMainContainerRef} />
                      <RouteTracker />

                          <div
                              style={{
                                width: "1px",
                                height: "1px",
                                overflow: "hidden",
                                position: "absolute",
                              }}
                            >
                              <GptAd id="div-gpt-tracker" />
                            </div>
                       </div>
                         
                     
                      

                       
             )
}

export default Photos;
